import React from "react";
import * as styleGlobal from "../infra/styleGlobal";
import { Paper, useTheme } from "@mui/material";
const Card = (props) => {
  const theme = useTheme();
  const classes = {
    root: {
      display: "block",
      padding: 12,
      paddingTop: 0,
      flex: 1,
      [theme.breakpoints.down(styleGlobal.breakMobile)]: {
        padding: 5,
      },
    },
  };

  let { style, children, key, paper } = props;
  return (
    <Paper
      sx={classes.root}
      style={{
        ...style,
      }}
      {...props}
    >
      {children}
    </Paper>
  );
};

export default Card;
